import constants from '../constants.js';

const CarSuppliersChainLogo = {
  displayName: 'Chain Logo',
  dataAt: 'ChainLogo',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'CarSupplier',
  uploadType: 'image'
};

const CarSuppliersCompanyShortName = {
  displayName: 'Company Short Name',
  dataAt: 'CompanyShortName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CarSuppliersId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const CarSuppliersTabsInfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [CarSuppliersId, CarSuppliersTitle, CarSuppliersCode, CarSuppliersCompanyShortName, CarSuppliersChainLogo]
};

const CarSuppliersCode = {displayName: 'Code', dataAt: 'Code', displayAs: constants.DISPLAY_AS.TEXT_INPUT};

const CarSuppliersTitle = {
  displayName: 'Title',
  dataAt: 'Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CarSuppliersTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [CarSuppliersTabsInfoPanel]
};

const CarSuppliersNameLabel = {dataAt: 'Title', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Title:'};

const CarSuppliersAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Car Supplier',
  data: {Title: '', Code: ''},
  dataAt: '',
  children: [CarSuppliersTitle, CarSuppliersCode],
  endpoint: 'CarSuppliers'
};

const CarSuppliersResource = {
  displayName: 'Car Suppliers',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [CarSuppliersNameLabel, CarSuppliersTabs],
  endpoint: 'CarSuppliers',
  routeParamId: 'carSupId'
};

const CarSuppliersList = {
  rootNode: true,
  displayName: 'Car Suppliers',
  endpoint: 'CarSuppliers',
  iconClass: 'fa-car',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: CarSuppliersResource,
  gridAdd: CarSuppliersAddResource,
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Code', key: 'Code'}]
};

export default {
  CarSuppliersList,
  CarSuppliersResource,
  CarSuppliersAddResource,
  CarSuppliersNameLabel,
  CarSuppliersTabs,
  CarSuppliersTitle,
  CarSuppliersCode,
  CarSuppliersTabsInfoPanel,
  CarSuppliersId,
  CarSuppliersCompanyShortName,
  CarSuppliersChainLogo
}



// WEBPACK FOOTER //
// ./src/config/fields/carSuppliers.js